var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "trs-simple-fade" } }, [
    _vm.isVisible
      ? _c(
          "div",
          {
            staticClass: "header-search",
            attrs: { itemscope: "", itemtype: "https://schema.org/WebSite" },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("meta", { attrs: { itemprop: "url", content: _vm.siteUrl } }),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: {
                  itemprop: "potentialAction",
                  itemscope: "",
                  itemtype: "https://schema.org/SearchAction",
                  action: _vm.action,
                  type: _vm.type
                }
              },
              [
                _c("meta", {
                  attrs: { itemprop: "target", content: _vm.searchURISchema }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "header-search--row" }, [
                  _c("div", { staticClass: "header-search--top-wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-search--col__side header-search--col"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "header-search--submit",
                            attrs: { type: "submit" }
                          },
                          [
                            _c("ui-icon", {
                              attrs: { symbol: "search", size: "medium" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-search--col__main header-search--col"
                      },
                      [
                        _c("input", {
                          ref: "input",
                          staticClass: "header-search--input",
                          attrs: {
                            required: "",
                            itemprop: "query-input",
                            type: "search",
                            name: _vm.name,
                            placeholder: _vm.placeholder
                          },
                          on: { keyup: _vm.detectEasterEgg }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "header-search--col__tail header-search--col"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "header-search--close",
                            attrs: {
                              "aria-label": _vm.searchButtonTitle,
                              title: _vm.searchButtonTitle
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.hide($event)
                              }
                            }
                          },
                          [
                            _c("ui-icon", {
                              attrs: {
                                symbol: "close",
                                size: _vm.closeIconSize
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "header-search--row" }, [
              _c("div", {
                staticClass: "header-search--col__side header-search--col"
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-search--col__main header-search--col" },
                [
                  _c("nav", { staticClass: "header-search--quick-links" }, [
                    _c("h2", { staticClass: "header-search--title u-reset" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.quickLinksTitle) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "header-search--collection u-reset" },
                      _vm._l(_vm.quickLinks, function(link, index) {
                        return _c(
                          "li",
                          { key: index, staticClass: "header-search--item" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "header-search--link u-reset",
                                style: _vm.getItemCss(index),
                                attrs: { href: link.path }
                              },
                              [_vm._v(_vm._s(link.label))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-179fbed6", { render: render, staticRenderFns: staticRenderFns })
  }
}